module.exports = __webpack_public_path__ + "img/ajdhr-gnrsi.1d5dc418.png";